import Seller from "../../entities/Seller";
import Pagination from "../../entities/Pagination";
import {action, computed, makeObservable, observable, runInAction} from "mobx";
import {SellerService} from "../../service/SellerService";
import CommonStore from "../../stores/CommonStore";
import SellerStatus from "../../entities/SellerStatus";

class SellerStore {

    public sellers: Seller[];
    public pagination: Pagination;
    public filter?: string;
    public statusFilter?: SellerStatus;
    public commonStore: CommonStore;


    constructor(commonStore: CommonStore) {
        this.pagination = new Pagination(1, 15, 0, 0);
        this.sellers = [];
        this.commonStore = commonStore;
        makeObservable(this, {
            sellers: observable,
            pagination: observable,
            isEmpty: computed
        });
    }

    get isEmpty(): boolean {
        return this.sellers.length === 0;
    }

    public setFilter(filer: string) {
        this.filter = filer;
    }

    @action
    public async search() {
        await this.getElements(1);
    }


    @action
    public async goToPage(page: number = this.pagination.currentPage, pageSize: number = this.pagination.pageSize): Promise<void> {
        await this.getElements(page, pageSize);
    }

    @action
    public async getElements(page: number = this.pagination.currentPage, pageSize: number = this.pagination.pageSize): Promise<void> {
        this.commonStore.setLoading();
        const response = await SellerService.get(page, pageSize, this.filter);
        if (response.success) {
            runInAction(() => {
                this.sellers = response.data?.data || [];
                this.pagination = response.data?.pagination || this.pagination;
            })
        }
        this.commonStore.processErrors(response);
        this.commonStore.removeLoading();
    }

}

export default SellerStore;